
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");














var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
function $ced39bfea5ef5993$export$9f275aff884e1431(t0) {
    const $ = (0, $frIzR.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
}
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader(t0) {
    const $ = (0, $frIzR.c)(33);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            setIsCloseMenuDisabled(true);
            return ()=>{
                setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== extension || $[29] !== onInitialRender || $[30] !== t11 || $[31] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12
        }));
        $[28] = extension;
        $[29] = onInitialRender;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("9rhQB"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("8ZagN"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("ekdxw"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("kdKUC"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("gY0Mm"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("jDLfc"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("4TEGo"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("8zAd2"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("156Ga"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("lsu4M"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("24HR1"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("4RX3T"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("9rhQB", function(module, exports) {

let $6df47aca42721c6d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6df47aca42721c6d$var$load("2YffH"),
    $6df47aca42721c6d$var$load("lMdi0"),
    $6df47aca42721c6d$var$load("lqFMg"),
    $6df47aca42721c6d$var$load("dFBsl"),
    $6df47aca42721c6d$var$load("ciPY8"),
    $6df47aca42721c6d$var$load("iQ0Jm"),
    $6df47aca42721c6d$var$load("edaDG"),
    $6df47aca42721c6d$var$load("2wk8c"),
    $6df47aca42721c6d$var$load("eBRUf"),
    $6df47aca42721c6d$var$load("70l64"),
    $6df47aca42721c6d$var$load("7czq2"),
    $6df47aca42721c6d$var$load("53pgU"),
    $6df47aca42721c6d$var$load("h4Nf7"),
    $6df47aca42721c6d$var$load("7f9Fz"),
    $6df47aca42721c6d$var$load("8YSo7"),
    $6df47aca42721c6d$var$load("lu4e5"),
    $6df47aca42721c6d$var$load("fuKGN"),
    $6df47aca42721c6d$var$load("4IYLb"),
    $6df47aca42721c6d$var$load("g9CVe"),
    $6df47aca42721c6d$var$load("3w411"),
    $6df47aca42721c6d$var$load("fSobj"),
    $6df47aca42721c6d$var$load("74u2y"),
    $6df47aca42721c6d$var$load("6wr18"),
    $6df47aca42721c6d$var$load("kjZZD"),
    $6df47aca42721c6d$var$load("9u7sS"),
    $6df47aca42721c6d$var$load("1fem1"),
    $6df47aca42721c6d$var$load("Wowvf"),
    $6df47aca42721c6d$var$load("kHOMt"),
    $6df47aca42721c6d$var$load("dRpV3"),
    $6df47aca42721c6d$var$load("ffEVr"),
    $6df47aca42721c6d$var$load("hhss7"),
    $6df47aca42721c6d$var$load("5Zg4L"),
    $6df47aca42721c6d$var$load("ik1cX"),
    $6df47aca42721c6d$var$load("6u1hm"),
    $6df47aca42721c6d$var$load("hHy5c"),
    $6df47aca42721c6d$var$load("er7wn"),
    $6df47aca42721c6d$var$load("iqKwT"),
    $6df47aca42721c6d$var$load("kzLFa"),
    $6df47aca42721c6d$var$load("2uVTT"),
    $6df47aca42721c6d$var$load("8ee3Z"),
    $6df47aca42721c6d$var$load("fleTp"),
    $6df47aca42721c6d$var$load("h305A"),
    $6df47aca42721c6d$var$load("hJpvQ"),
    $6df47aca42721c6d$var$load("bIPPg"),
    $6df47aca42721c6d$var$load("lnKog"),
    $6df47aca42721c6d$var$load("9ftJe"),
    $6df47aca42721c6d$var$load("h3ABO"),
    $6df47aca42721c6d$var$load("kC80R"),
    $6df47aca42721c6d$var$load("7EorR"),
    $6df47aca42721c6d$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("8ZagN", function(module, exports) {

let $68abfc9fe9250c53$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $68abfc9fe9250c53$var$load("2YffH"),
    $68abfc9fe9250c53$var$load("lMdi0"),
    $68abfc9fe9250c53$var$load("lqFMg"),
    $68abfc9fe9250c53$var$load("dFBsl"),
    $68abfc9fe9250c53$var$load("ciPY8"),
    $68abfc9fe9250c53$var$load("iQ0Jm"),
    $68abfc9fe9250c53$var$load("edaDG"),
    $68abfc9fe9250c53$var$load("2wk8c"),
    $68abfc9fe9250c53$var$load("eBRUf"),
    $68abfc9fe9250c53$var$load("70l64"),
    $68abfc9fe9250c53$var$load("7czq2"),
    $68abfc9fe9250c53$var$load("53pgU"),
    $68abfc9fe9250c53$var$load("h4Nf7"),
    $68abfc9fe9250c53$var$load("7f9Fz"),
    $68abfc9fe9250c53$var$load("8YSo7"),
    $68abfc9fe9250c53$var$load("lu4e5"),
    $68abfc9fe9250c53$var$load("fuKGN"),
    $68abfc9fe9250c53$var$load("4IYLb"),
    $68abfc9fe9250c53$var$load("g9CVe"),
    $68abfc9fe9250c53$var$load("3w411"),
    $68abfc9fe9250c53$var$load("fSobj"),
    $68abfc9fe9250c53$var$load("74u2y"),
    $68abfc9fe9250c53$var$load("6wr18"),
    $68abfc9fe9250c53$var$load("kjZZD"),
    $68abfc9fe9250c53$var$load("9u7sS"),
    $68abfc9fe9250c53$var$load("1fem1"),
    $68abfc9fe9250c53$var$load("Wowvf"),
    $68abfc9fe9250c53$var$load("kHOMt"),
    $68abfc9fe9250c53$var$load("dRpV3"),
    $68abfc9fe9250c53$var$load("ffEVr"),
    $68abfc9fe9250c53$var$load("hhss7"),
    $68abfc9fe9250c53$var$load("5Zg4L"),
    $68abfc9fe9250c53$var$load("ik1cX"),
    $68abfc9fe9250c53$var$load("6u1hm"),
    $68abfc9fe9250c53$var$load("hHy5c"),
    $68abfc9fe9250c53$var$load("er7wn"),
    $68abfc9fe9250c53$var$load("iqKwT"),
    $68abfc9fe9250c53$var$load("kzLFa"),
    $68abfc9fe9250c53$var$load("2uVTT"),
    $68abfc9fe9250c53$var$load("8ee3Z"),
    $68abfc9fe9250c53$var$load("fleTp"),
    $68abfc9fe9250c53$var$load("h305A"),
    $68abfc9fe9250c53$var$load("hJpvQ"),
    $68abfc9fe9250c53$var$load("bIPPg"),
    $68abfc9fe9250c53$var$load("lnKog"),
    $68abfc9fe9250c53$var$load("9ftJe"),
    $68abfc9fe9250c53$var$load("h3ABO"),
    $68abfc9fe9250c53$var$load("kC80R"),
    $68abfc9fe9250c53$var$load("7EorR"),
    $68abfc9fe9250c53$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("ekdxw", function(module, exports) {

let $a6dd6fa470ad49f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a6dd6fa470ad49f1$var$load("2YffH"),
    $a6dd6fa470ad49f1$var$load("lMdi0"),
    $a6dd6fa470ad49f1$var$load("lqFMg"),
    $a6dd6fa470ad49f1$var$load("dFBsl"),
    $a6dd6fa470ad49f1$var$load("ciPY8"),
    $a6dd6fa470ad49f1$var$load("iQ0Jm"),
    $a6dd6fa470ad49f1$var$load("edaDG"),
    $a6dd6fa470ad49f1$var$load("2wk8c"),
    $a6dd6fa470ad49f1$var$load("eBRUf"),
    $a6dd6fa470ad49f1$var$load("70l64"),
    $a6dd6fa470ad49f1$var$load("7czq2"),
    $a6dd6fa470ad49f1$var$load("53pgU"),
    $a6dd6fa470ad49f1$var$load("h4Nf7"),
    $a6dd6fa470ad49f1$var$load("7f9Fz"),
    $a6dd6fa470ad49f1$var$load("8YSo7"),
    $a6dd6fa470ad49f1$var$load("lu4e5"),
    $a6dd6fa470ad49f1$var$load("fuKGN"),
    $a6dd6fa470ad49f1$var$load("4IYLb"),
    $a6dd6fa470ad49f1$var$load("g9CVe"),
    $a6dd6fa470ad49f1$var$load("3w411"),
    $a6dd6fa470ad49f1$var$load("fSobj"),
    $a6dd6fa470ad49f1$var$load("74u2y"),
    $a6dd6fa470ad49f1$var$load("6wr18"),
    $a6dd6fa470ad49f1$var$load("kjZZD"),
    $a6dd6fa470ad49f1$var$load("9u7sS"),
    $a6dd6fa470ad49f1$var$load("1fem1"),
    $a6dd6fa470ad49f1$var$load("Wowvf"),
    $a6dd6fa470ad49f1$var$load("kHOMt"),
    $a6dd6fa470ad49f1$var$load("dRpV3"),
    $a6dd6fa470ad49f1$var$load("ffEVr"),
    $a6dd6fa470ad49f1$var$load("hhss7"),
    $a6dd6fa470ad49f1$var$load("5Zg4L"),
    $a6dd6fa470ad49f1$var$load("ik1cX"),
    $a6dd6fa470ad49f1$var$load("6u1hm"),
    $a6dd6fa470ad49f1$var$load("hHy5c"),
    $a6dd6fa470ad49f1$var$load("er7wn"),
    $a6dd6fa470ad49f1$var$load("iqKwT"),
    $a6dd6fa470ad49f1$var$load("kzLFa"),
    $a6dd6fa470ad49f1$var$load("2uVTT"),
    $a6dd6fa470ad49f1$var$load("8ee3Z"),
    $a6dd6fa470ad49f1$var$load("fleTp"),
    $a6dd6fa470ad49f1$var$load("h305A"),
    $a6dd6fa470ad49f1$var$load("hJpvQ"),
    $a6dd6fa470ad49f1$var$load("bIPPg"),
    $a6dd6fa470ad49f1$var$load("lnKog"),
    $a6dd6fa470ad49f1$var$load("9ftJe"),
    $a6dd6fa470ad49f1$var$load("h3ABO"),
    $a6dd6fa470ad49f1$var$load("kC80R"),
    $a6dd6fa470ad49f1$var$load("7EorR"),
    $a6dd6fa470ad49f1$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("kdKUC", function(module, exports) {

let $eb89695b55e7c9f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $eb89695b55e7c9f1$var$load("fuKGN"),
    $eb89695b55e7c9f1$var$load("4IYLb"),
    $eb89695b55e7c9f1$var$load("2YffH"),
    $eb89695b55e7c9f1$var$load("lqFMg"),
    $eb89695b55e7c9f1$var$load("dFBsl"),
    $eb89695b55e7c9f1$var$load("ciPY8"),
    $eb89695b55e7c9f1$var$load("hJpvQ"),
    $eb89695b55e7c9f1$var$load("edaDG"),
    $eb89695b55e7c9f1$var$load("2wk8c"),
    $eb89695b55e7c9f1$var$load("eBRUf"),
    $eb89695b55e7c9f1$var$load("70l64"),
    $eb89695b55e7c9f1$var$load("7czq2"),
    $eb89695b55e7c9f1$var$load("53pgU"),
    $eb89695b55e7c9f1$var$load("h4Nf7"),
    $eb89695b55e7c9f1$var$load("7f9Fz"),
    $eb89695b55e7c9f1$var$load("8YSo7"),
    $eb89695b55e7c9f1$var$load("g9CVe"),
    $eb89695b55e7c9f1$var$load("3w411"),
    $eb89695b55e7c9f1$var$load("fSobj"),
    $eb89695b55e7c9f1$var$load("74u2y"),
    $eb89695b55e7c9f1$var$load("6wr18"),
    $eb89695b55e7c9f1$var$load("kjZZD"),
    $eb89695b55e7c9f1$var$load("9u7sS"),
    $eb89695b55e7c9f1$var$load("1fem1"),
    $eb89695b55e7c9f1$var$load("Wowvf"),
    $eb89695b55e7c9f1$var$load("kHOMt"),
    $eb89695b55e7c9f1$var$load("dRpV3"),
    $eb89695b55e7c9f1$var$load("ffEVr"),
    $eb89695b55e7c9f1$var$load("hhss7"),
    $eb89695b55e7c9f1$var$load("5Zg4L"),
    $eb89695b55e7c9f1$var$load("ik1cX"),
    $eb89695b55e7c9f1$var$load("6u1hm"),
    $eb89695b55e7c9f1$var$load("hHy5c"),
    $eb89695b55e7c9f1$var$load("er7wn"),
    $eb89695b55e7c9f1$var$load("iqKwT"),
    $eb89695b55e7c9f1$var$load("kzLFa"),
    $eb89695b55e7c9f1$var$load("bIPPg"),
    $eb89695b55e7c9f1$var$load("2uVTT"),
    $eb89695b55e7c9f1$var$load("8ee3Z"),
    $eb89695b55e7c9f1$var$load("fleTp"),
    $eb89695b55e7c9f1$var$load("h305A"),
    $eb89695b55e7c9f1$var$load("9ftJe"),
    $eb89695b55e7c9f1$var$load("h3ABO"),
    $eb89695b55e7c9f1$var$load("kC80R"),
    $eb89695b55e7c9f1$var$load("7EorR"),
    $eb89695b55e7c9f1$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("gY0Mm", function(module, exports) {

let $c5a2daa1f25942f2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c5a2daa1f25942f2$var$load("fuKGN"),
    $c5a2daa1f25942f2$var$load("4IYLb"),
    $c5a2daa1f25942f2$var$load("2YffH"),
    $c5a2daa1f25942f2$var$load("lqFMg"),
    $c5a2daa1f25942f2$var$load("dFBsl"),
    $c5a2daa1f25942f2$var$load("ciPY8"),
    $c5a2daa1f25942f2$var$load("hJpvQ"),
    $c5a2daa1f25942f2$var$load("edaDG"),
    $c5a2daa1f25942f2$var$load("2wk8c"),
    $c5a2daa1f25942f2$var$load("eBRUf"),
    $c5a2daa1f25942f2$var$load("70l64"),
    $c5a2daa1f25942f2$var$load("7czq2"),
    $c5a2daa1f25942f2$var$load("53pgU"),
    $c5a2daa1f25942f2$var$load("h4Nf7"),
    $c5a2daa1f25942f2$var$load("7f9Fz"),
    $c5a2daa1f25942f2$var$load("8YSo7"),
    $c5a2daa1f25942f2$var$load("g9CVe"),
    $c5a2daa1f25942f2$var$load("3w411"),
    $c5a2daa1f25942f2$var$load("fSobj"),
    $c5a2daa1f25942f2$var$load("74u2y"),
    $c5a2daa1f25942f2$var$load("6wr18"),
    $c5a2daa1f25942f2$var$load("kjZZD"),
    $c5a2daa1f25942f2$var$load("9u7sS"),
    $c5a2daa1f25942f2$var$load("1fem1"),
    $c5a2daa1f25942f2$var$load("Wowvf"),
    $c5a2daa1f25942f2$var$load("kHOMt"),
    $c5a2daa1f25942f2$var$load("dRpV3"),
    $c5a2daa1f25942f2$var$load("ffEVr"),
    $c5a2daa1f25942f2$var$load("hhss7"),
    $c5a2daa1f25942f2$var$load("5Zg4L"),
    $c5a2daa1f25942f2$var$load("ik1cX"),
    $c5a2daa1f25942f2$var$load("6u1hm"),
    $c5a2daa1f25942f2$var$load("hHy5c"),
    $c5a2daa1f25942f2$var$load("er7wn"),
    $c5a2daa1f25942f2$var$load("iqKwT"),
    $c5a2daa1f25942f2$var$load("kzLFa"),
    $c5a2daa1f25942f2$var$load("bIPPg"),
    $c5a2daa1f25942f2$var$load("2uVTT"),
    $c5a2daa1f25942f2$var$load("8ee3Z"),
    $c5a2daa1f25942f2$var$load("fleTp"),
    $c5a2daa1f25942f2$var$load("h305A"),
    $c5a2daa1f25942f2$var$load("9ftJe"),
    $c5a2daa1f25942f2$var$load("h3ABO"),
    $c5a2daa1f25942f2$var$load("kC80R"),
    $c5a2daa1f25942f2$var$load("7EorR"),
    $c5a2daa1f25942f2$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("jDLfc", function(module, exports) {

let $e4c64e884a651816$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e4c64e884a651816$var$load("fuKGN"),
    $e4c64e884a651816$var$load("4IYLb"),
    $e4c64e884a651816$var$load("2YffH"),
    $e4c64e884a651816$var$load("lqFMg"),
    $e4c64e884a651816$var$load("dFBsl"),
    $e4c64e884a651816$var$load("ciPY8"),
    $e4c64e884a651816$var$load("hJpvQ"),
    $e4c64e884a651816$var$load("edaDG"),
    $e4c64e884a651816$var$load("2wk8c"),
    $e4c64e884a651816$var$load("eBRUf"),
    $e4c64e884a651816$var$load("70l64"),
    $e4c64e884a651816$var$load("7czq2"),
    $e4c64e884a651816$var$load("53pgU"),
    $e4c64e884a651816$var$load("h4Nf7"),
    $e4c64e884a651816$var$load("7f9Fz"),
    $e4c64e884a651816$var$load("8YSo7"),
    $e4c64e884a651816$var$load("g9CVe"),
    $e4c64e884a651816$var$load("3w411"),
    $e4c64e884a651816$var$load("fSobj"),
    $e4c64e884a651816$var$load("74u2y"),
    $e4c64e884a651816$var$load("6wr18"),
    $e4c64e884a651816$var$load("kjZZD"),
    $e4c64e884a651816$var$load("9u7sS"),
    $e4c64e884a651816$var$load("1fem1"),
    $e4c64e884a651816$var$load("Wowvf"),
    $e4c64e884a651816$var$load("kHOMt"),
    $e4c64e884a651816$var$load("dRpV3"),
    $e4c64e884a651816$var$load("ffEVr"),
    $e4c64e884a651816$var$load("hhss7"),
    $e4c64e884a651816$var$load("5Zg4L"),
    $e4c64e884a651816$var$load("ik1cX"),
    $e4c64e884a651816$var$load("6u1hm"),
    $e4c64e884a651816$var$load("hHy5c"),
    $e4c64e884a651816$var$load("er7wn"),
    $e4c64e884a651816$var$load("iqKwT"),
    $e4c64e884a651816$var$load("kzLFa"),
    $e4c64e884a651816$var$load("bIPPg"),
    $e4c64e884a651816$var$load("2uVTT"),
    $e4c64e884a651816$var$load("8ee3Z"),
    $e4c64e884a651816$var$load("fleTp"),
    $e4c64e884a651816$var$load("h305A"),
    $e4c64e884a651816$var$load("9ftJe"),
    $e4c64e884a651816$var$load("h3ABO"),
    $e4c64e884a651816$var$load("kC80R"),
    $e4c64e884a651816$var$load("7EorR"),
    $e4c64e884a651816$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("4TEGo", function(module, exports) {

let $390bdb3dd5c989fe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $390bdb3dd5c989fe$var$load("fuKGN"),
    $390bdb3dd5c989fe$var$load("4IYLb"),
    $390bdb3dd5c989fe$var$load("2YffH"),
    $390bdb3dd5c989fe$var$load("lqFMg"),
    $390bdb3dd5c989fe$var$load("dFBsl"),
    $390bdb3dd5c989fe$var$load("ciPY8"),
    $390bdb3dd5c989fe$var$load("edaDG"),
    $390bdb3dd5c989fe$var$load("2wk8c"),
    $390bdb3dd5c989fe$var$load("eBRUf"),
    $390bdb3dd5c989fe$var$load("70l64"),
    $390bdb3dd5c989fe$var$load("7czq2"),
    $390bdb3dd5c989fe$var$load("53pgU"),
    $390bdb3dd5c989fe$var$load("h4Nf7"),
    $390bdb3dd5c989fe$var$load("7f9Fz"),
    $390bdb3dd5c989fe$var$load("8YSo7"),
    $390bdb3dd5c989fe$var$load("g9CVe"),
    $390bdb3dd5c989fe$var$load("3w411"),
    $390bdb3dd5c989fe$var$load("fSobj"),
    $390bdb3dd5c989fe$var$load("74u2y"),
    $390bdb3dd5c989fe$var$load("6wr18"),
    $390bdb3dd5c989fe$var$load("kjZZD"),
    $390bdb3dd5c989fe$var$load("9u7sS"),
    $390bdb3dd5c989fe$var$load("1fem1"),
    $390bdb3dd5c989fe$var$load("Wowvf"),
    $390bdb3dd5c989fe$var$load("kHOMt"),
    $390bdb3dd5c989fe$var$load("dRpV3"),
    $390bdb3dd5c989fe$var$load("ffEVr"),
    $390bdb3dd5c989fe$var$load("hhss7"),
    $390bdb3dd5c989fe$var$load("5Zg4L"),
    $390bdb3dd5c989fe$var$load("ik1cX"),
    $390bdb3dd5c989fe$var$load("6u1hm"),
    $390bdb3dd5c989fe$var$load("hHy5c"),
    $390bdb3dd5c989fe$var$load("er7wn"),
    $390bdb3dd5c989fe$var$load("iqKwT"),
    $390bdb3dd5c989fe$var$load("kzLFa"),
    $390bdb3dd5c989fe$var$load("2uVTT"),
    $390bdb3dd5c989fe$var$load("8ee3Z"),
    $390bdb3dd5c989fe$var$load("fleTp"),
    $390bdb3dd5c989fe$var$load("h305A"),
    $390bdb3dd5c989fe$var$load("hJpvQ"),
    $390bdb3dd5c989fe$var$load("bIPPg"),
    $390bdb3dd5c989fe$var$load("lnKog"),
    $390bdb3dd5c989fe$var$load("9ftJe"),
    $390bdb3dd5c989fe$var$load("h3ABO"),
    $390bdb3dd5c989fe$var$load("kC80R"),
    $390bdb3dd5c989fe$var$load("7EorR"),
    $390bdb3dd5c989fe$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("8zAd2", function(module, exports) {

let $63ddae05d33206c1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $63ddae05d33206c1$var$load("2YffH"),
    $63ddae05d33206c1$var$load("lqFMg"),
    $63ddae05d33206c1$var$load("dFBsl"),
    $63ddae05d33206c1$var$load("ciPY8"),
    $63ddae05d33206c1$var$load("edaDG"),
    $63ddae05d33206c1$var$load("2wk8c"),
    $63ddae05d33206c1$var$load("eBRUf"),
    $63ddae05d33206c1$var$load("70l64"),
    $63ddae05d33206c1$var$load("7czq2"),
    $63ddae05d33206c1$var$load("53pgU"),
    $63ddae05d33206c1$var$load("h4Nf7"),
    $63ddae05d33206c1$var$load("7f9Fz"),
    $63ddae05d33206c1$var$load("8YSo7"),
    $63ddae05d33206c1$var$load("lu4e5"),
    $63ddae05d33206c1$var$load("fuKGN"),
    $63ddae05d33206c1$var$load("4IYLb"),
    $63ddae05d33206c1$var$load("g9CVe"),
    $63ddae05d33206c1$var$load("3w411"),
    $63ddae05d33206c1$var$load("fSobj"),
    $63ddae05d33206c1$var$load("74u2y"),
    $63ddae05d33206c1$var$load("6wr18"),
    $63ddae05d33206c1$var$load("kjZZD"),
    $63ddae05d33206c1$var$load("9u7sS"),
    $63ddae05d33206c1$var$load("1fem1"),
    $63ddae05d33206c1$var$load("Wowvf"),
    $63ddae05d33206c1$var$load("kHOMt"),
    $63ddae05d33206c1$var$load("dRpV3"),
    $63ddae05d33206c1$var$load("ffEVr"),
    $63ddae05d33206c1$var$load("dTsOE"),
    $63ddae05d33206c1$var$load("hhss7"),
    $63ddae05d33206c1$var$load("5Zg4L"),
    $63ddae05d33206c1$var$load("ik1cX"),
    $63ddae05d33206c1$var$load("6u1hm"),
    $63ddae05d33206c1$var$load("hHy5c"),
    $63ddae05d33206c1$var$load("er7wn"),
    $63ddae05d33206c1$var$load("iqKwT"),
    $63ddae05d33206c1$var$load("kzLFa"),
    $63ddae05d33206c1$var$load("2uVTT"),
    $63ddae05d33206c1$var$load("8ee3Z"),
    $63ddae05d33206c1$var$load("fleTp"),
    $63ddae05d33206c1$var$load("h305A"),
    $63ddae05d33206c1$var$load("hJpvQ"),
    $63ddae05d33206c1$var$load("bIPPg"),
    $63ddae05d33206c1$var$load("lnKog"),
    $63ddae05d33206c1$var$load("9ftJe"),
    $63ddae05d33206c1$var$load("h3ABO"),
    $63ddae05d33206c1$var$load("kC80R"),
    $63ddae05d33206c1$var$load("7EorR"),
    $63ddae05d33206c1$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("156Ga", function(module, exports) {

let $0c9b706abc63c0f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0c9b706abc63c0f0$var$load("2YffH"),
    $0c9b706abc63c0f0$var$load("lqFMg"),
    $0c9b706abc63c0f0$var$load("dFBsl"),
    $0c9b706abc63c0f0$var$load("ciPY8"),
    $0c9b706abc63c0f0$var$load("edaDG"),
    $0c9b706abc63c0f0$var$load("2wk8c"),
    $0c9b706abc63c0f0$var$load("eBRUf"),
    $0c9b706abc63c0f0$var$load("70l64"),
    $0c9b706abc63c0f0$var$load("7czq2"),
    $0c9b706abc63c0f0$var$load("53pgU"),
    $0c9b706abc63c0f0$var$load("h4Nf7"),
    $0c9b706abc63c0f0$var$load("7f9Fz"),
    $0c9b706abc63c0f0$var$load("8YSo7"),
    $0c9b706abc63c0f0$var$load("lu4e5"),
    $0c9b706abc63c0f0$var$load("fuKGN"),
    $0c9b706abc63c0f0$var$load("4IYLb"),
    $0c9b706abc63c0f0$var$load("g9CVe"),
    $0c9b706abc63c0f0$var$load("3w411"),
    $0c9b706abc63c0f0$var$load("fSobj"),
    $0c9b706abc63c0f0$var$load("74u2y"),
    $0c9b706abc63c0f0$var$load("6wr18"),
    $0c9b706abc63c0f0$var$load("kjZZD"),
    $0c9b706abc63c0f0$var$load("9u7sS"),
    $0c9b706abc63c0f0$var$load("1fem1"),
    $0c9b706abc63c0f0$var$load("Wowvf"),
    $0c9b706abc63c0f0$var$load("kHOMt"),
    $0c9b706abc63c0f0$var$load("dRpV3"),
    $0c9b706abc63c0f0$var$load("ffEVr"),
    $0c9b706abc63c0f0$var$load("dTsOE"),
    $0c9b706abc63c0f0$var$load("hhss7"),
    $0c9b706abc63c0f0$var$load("5Zg4L"),
    $0c9b706abc63c0f0$var$load("ik1cX"),
    $0c9b706abc63c0f0$var$load("6u1hm"),
    $0c9b706abc63c0f0$var$load("hHy5c"),
    $0c9b706abc63c0f0$var$load("er7wn"),
    $0c9b706abc63c0f0$var$load("iqKwT"),
    $0c9b706abc63c0f0$var$load("kzLFa"),
    $0c9b706abc63c0f0$var$load("2uVTT"),
    $0c9b706abc63c0f0$var$load("8ee3Z"),
    $0c9b706abc63c0f0$var$load("fleTp"),
    $0c9b706abc63c0f0$var$load("h305A"),
    $0c9b706abc63c0f0$var$load("hJpvQ"),
    $0c9b706abc63c0f0$var$load("bIPPg"),
    $0c9b706abc63c0f0$var$load("lnKog"),
    $0c9b706abc63c0f0$var$load("9ftJe"),
    $0c9b706abc63c0f0$var$load("h3ABO"),
    $0c9b706abc63c0f0$var$load("kC80R"),
    $0c9b706abc63c0f0$var$load("7EorR"),
    $0c9b706abc63c0f0$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("lsu4M", function(module, exports) {

let $f9f38af85bb474ec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f9f38af85bb474ec$var$load("fuKGN"),
    $f9f38af85bb474ec$var$load("4IYLb"),
    $f9f38af85bb474ec$var$load("2YffH"),
    $f9f38af85bb474ec$var$load("lqFMg"),
    $f9f38af85bb474ec$var$load("dFBsl"),
    $f9f38af85bb474ec$var$load("ciPY8"),
    $f9f38af85bb474ec$var$load("hJpvQ"),
    $f9f38af85bb474ec$var$load("edaDG"),
    $f9f38af85bb474ec$var$load("2wk8c"),
    $f9f38af85bb474ec$var$load("eBRUf"),
    $f9f38af85bb474ec$var$load("70l64"),
    $f9f38af85bb474ec$var$load("7czq2"),
    $f9f38af85bb474ec$var$load("53pgU"),
    $f9f38af85bb474ec$var$load("h4Nf7"),
    $f9f38af85bb474ec$var$load("7f9Fz"),
    $f9f38af85bb474ec$var$load("8YSo7"),
    $f9f38af85bb474ec$var$load("g9CVe"),
    $f9f38af85bb474ec$var$load("3w411"),
    $f9f38af85bb474ec$var$load("fSobj"),
    $f9f38af85bb474ec$var$load("74u2y"),
    $f9f38af85bb474ec$var$load("6wr18"),
    $f9f38af85bb474ec$var$load("kjZZD"),
    $f9f38af85bb474ec$var$load("9u7sS"),
    $f9f38af85bb474ec$var$load("1fem1"),
    $f9f38af85bb474ec$var$load("Wowvf"),
    $f9f38af85bb474ec$var$load("kHOMt"),
    $f9f38af85bb474ec$var$load("dRpV3"),
    $f9f38af85bb474ec$var$load("ffEVr"),
    $f9f38af85bb474ec$var$load("hhss7"),
    $f9f38af85bb474ec$var$load("5Zg4L"),
    $f9f38af85bb474ec$var$load("ik1cX"),
    $f9f38af85bb474ec$var$load("6u1hm"),
    $f9f38af85bb474ec$var$load("hHy5c"),
    $f9f38af85bb474ec$var$load("er7wn"),
    $f9f38af85bb474ec$var$load("iqKwT"),
    $f9f38af85bb474ec$var$load("kzLFa"),
    $f9f38af85bb474ec$var$load("bIPPg"),
    $f9f38af85bb474ec$var$load("2uVTT"),
    $f9f38af85bb474ec$var$load("8ee3Z"),
    $f9f38af85bb474ec$var$load("fleTp"),
    $f9f38af85bb474ec$var$load("h305A"),
    $f9f38af85bb474ec$var$load("9ftJe"),
    $f9f38af85bb474ec$var$load("h3ABO"),
    $f9f38af85bb474ec$var$load("kC80R"),
    $f9f38af85bb474ec$var$load("7EorR"),
    $f9f38af85bb474ec$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("24HR1", function(module, exports) {

let $182df908632e6a5f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $182df908632e6a5f$var$load("fuKGN"),
    $182df908632e6a5f$var$load("4IYLb"),
    $182df908632e6a5f$var$load("2YffH"),
    $182df908632e6a5f$var$load("lqFMg"),
    $182df908632e6a5f$var$load("dFBsl"),
    $182df908632e6a5f$var$load("ciPY8"),
    $182df908632e6a5f$var$load("edaDG"),
    $182df908632e6a5f$var$load("2wk8c"),
    $182df908632e6a5f$var$load("eBRUf"),
    $182df908632e6a5f$var$load("70l64"),
    $182df908632e6a5f$var$load("7czq2"),
    $182df908632e6a5f$var$load("53pgU"),
    $182df908632e6a5f$var$load("h4Nf7"),
    $182df908632e6a5f$var$load("7f9Fz"),
    $182df908632e6a5f$var$load("8YSo7"),
    $182df908632e6a5f$var$load("g9CVe"),
    $182df908632e6a5f$var$load("3w411"),
    $182df908632e6a5f$var$load("fSobj"),
    $182df908632e6a5f$var$load("74u2y"),
    $182df908632e6a5f$var$load("6wr18"),
    $182df908632e6a5f$var$load("kjZZD"),
    $182df908632e6a5f$var$load("9u7sS"),
    $182df908632e6a5f$var$load("1fem1"),
    $182df908632e6a5f$var$load("Wowvf"),
    $182df908632e6a5f$var$load("kHOMt"),
    $182df908632e6a5f$var$load("dRpV3"),
    $182df908632e6a5f$var$load("ffEVr"),
    $182df908632e6a5f$var$load("hhss7"),
    $182df908632e6a5f$var$load("5Zg4L"),
    $182df908632e6a5f$var$load("ik1cX"),
    $182df908632e6a5f$var$load("6u1hm"),
    $182df908632e6a5f$var$load("hHy5c"),
    $182df908632e6a5f$var$load("er7wn"),
    $182df908632e6a5f$var$load("iqKwT"),
    $182df908632e6a5f$var$load("kzLFa"),
    $182df908632e6a5f$var$load("2uVTT"),
    $182df908632e6a5f$var$load("8ee3Z"),
    $182df908632e6a5f$var$load("fleTp"),
    $182df908632e6a5f$var$load("h305A"),
    $182df908632e6a5f$var$load("hJpvQ"),
    $182df908632e6a5f$var$load("bIPPg"),
    $182df908632e6a5f$var$load("lnKog"),
    $182df908632e6a5f$var$load("9ftJe"),
    $182df908632e6a5f$var$load("h3ABO"),
    $182df908632e6a5f$var$load("kC80R"),
    $182df908632e6a5f$var$load("7EorR"),
    $182df908632e6a5f$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("4RX3T", function(module, exports) {

let $38b9ed17cd1971bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $38b9ed17cd1971bd$var$load("fuKGN"),
    $38b9ed17cd1971bd$var$load("4IYLb"),
    $38b9ed17cd1971bd$var$load("2YffH"),
    $38b9ed17cd1971bd$var$load("lqFMg"),
    $38b9ed17cd1971bd$var$load("dFBsl"),
    $38b9ed17cd1971bd$var$load("ciPY8"),
    $38b9ed17cd1971bd$var$load("edaDG"),
    $38b9ed17cd1971bd$var$load("2wk8c"),
    $38b9ed17cd1971bd$var$load("eBRUf"),
    $38b9ed17cd1971bd$var$load("70l64"),
    $38b9ed17cd1971bd$var$load("7czq2"),
    $38b9ed17cd1971bd$var$load("53pgU"),
    $38b9ed17cd1971bd$var$load("h4Nf7"),
    $38b9ed17cd1971bd$var$load("7f9Fz"),
    $38b9ed17cd1971bd$var$load("8YSo7"),
    $38b9ed17cd1971bd$var$load("g9CVe"),
    $38b9ed17cd1971bd$var$load("3w411"),
    $38b9ed17cd1971bd$var$load("fSobj"),
    $38b9ed17cd1971bd$var$load("74u2y"),
    $38b9ed17cd1971bd$var$load("6wr18"),
    $38b9ed17cd1971bd$var$load("kjZZD"),
    $38b9ed17cd1971bd$var$load("9u7sS"),
    $38b9ed17cd1971bd$var$load("1fem1"),
    $38b9ed17cd1971bd$var$load("Wowvf"),
    $38b9ed17cd1971bd$var$load("kHOMt"),
    $38b9ed17cd1971bd$var$load("dRpV3"),
    $38b9ed17cd1971bd$var$load("ffEVr"),
    $38b9ed17cd1971bd$var$load("hhss7"),
    $38b9ed17cd1971bd$var$load("5Zg4L"),
    $38b9ed17cd1971bd$var$load("ik1cX"),
    $38b9ed17cd1971bd$var$load("6u1hm"),
    $38b9ed17cd1971bd$var$load("hHy5c"),
    $38b9ed17cd1971bd$var$load("er7wn"),
    $38b9ed17cd1971bd$var$load("iqKwT"),
    $38b9ed17cd1971bd$var$load("kzLFa"),
    $38b9ed17cd1971bd$var$load("2uVTT"),
    $38b9ed17cd1971bd$var$load("8ee3Z"),
    $38b9ed17cd1971bd$var$load("fleTp"),
    $38b9ed17cd1971bd$var$load("h305A"),
    $38b9ed17cd1971bd$var$load("hJpvQ"),
    $38b9ed17cd1971bd$var$load("bIPPg"),
    $38b9ed17cd1971bd$var$load("lnKog"),
    $38b9ed17cd1971bd$var$load("9ftJe"),
    $38b9ed17cd1971bd$var$load("h3ABO"),
    $38b9ed17cd1971bd$var$load("kC80R"),
    $38b9ed17cd1971bd$var$load("7EorR"),
    $38b9ed17cd1971bd$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("lk93G"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("lk93G", function(module, exports) {

let $f8627e0aeed3fccf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f8627e0aeed3fccf$var$load("hJpvQ"),
    $f8627e0aeed3fccf$var$load("bIPPg"),
    $f8627e0aeed3fccf$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $cgtv4.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $8C5kA.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.765e4290.js.map
